export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "92a5da62-1669-40f5-89d3-e7be1480820a";
export const MODAL_CLOSE_SEC = 2.5;
